import type {
  Customer,
  WalletTransaction,
  PointsTransaction,
  TierConfig,
  Promotion,
  StaffAccount,
  AuditLog,
  Reward,
  WalletSettings,
  PointsSettings,
  NotificationTemplate,
  Purchase,
  DashboardStats,
  ChartDataPoint,
} from './types'

export const TIER_CONFIGS: TierConfig[] = [
  {
    level: 'member',
    name: 'Member',
    nameVi: 'Thành Viên',
    minPoints: 0,
    maxPoints: 999,
    discountPercent: 0,
    pointMultiplier: 1,
    hasBirthdayGift: false,
    hasExclusivePromos: false,
    color: '#666666',
    icon: '🏷️',
  },
  {
    level: 'silver',
    name: 'Silver',
    nameVi: 'Bạc',
    minPoints: 1000,
    maxPoints: 4999,
    discountPercent: 0,
    pointMultiplier: 1.2,
    hasBirthdayGift: true,
    hasExclusivePromos: false,
    color: '#A0AEC0',
    icon: '🥈',
  },
  {
    level: 'gold',
    name: 'Gold',
    nameVi: 'Vàng',
    minPoints: 5000,
    maxPoints: 14999,
    discountPercent: 0,
    pointMultiplier: 1.5,
    hasBirthdayGift: true,
    hasExclusivePromos: true,
    color: '#C8A84E',
    icon: '🥇',
  },
  {
    level: 'vip',
    name: 'VIP',
    nameVi: 'VIP',
    minPoints: 15000,
    maxPoints: null,
    discountPercent: 0,
    pointMultiplier: 2,
    hasBirthdayGift: true,
    hasExclusivePromos: true,
    color: '#EF4444',
    icon: '👑',
  },
]

export const MOCK_CUSTOMERS: Customer[] = [
  {
    id: 'c1',
    phone: '0901234567',
    name: 'Nguyễn Văn An',
    dateOfBirth: '1985-03-15',
    gender: 'male',
    tier: 'gold',
    points: 8750,
    walletBalance: 45_300_000,
    totalDeposited: 120_000_000,
    totalBonusEarned: 3_600_000,
    totalSpent: 78_300_000,
    referralCode: 'AN3K7X',
    createdAt: '2024-01-15T08:00:00Z',
    lastPurchaseAt: '2025-02-10T14:30:00Z',
    tags: ['frequent-buyer'],
    notificationPreferences: { sms: true, zalo: true, email: false },
  },
  {
    id: 'c2',
    phone: '0912345678',
    name: 'Trần Thị Bích',
    dateOfBirth: '1990-07-22',
    gender: 'female',
    tier: 'vip',
    points: 22300,
    walletBalance: 85_000_000,
    totalDeposited: 250_000_000,
    totalBonusEarned: 7_500_000,
    totalSpent: 172_500_000,
    referralCode: 'BICH9M',
    createdAt: '2023-06-10T10:00:00Z',
    lastPurchaseAt: '2025-02-12T09:15:00Z',
    tags: ['vip', 'high-deposit', 'frequent-buyer'],
    notificationPreferences: { sms: true, zalo: true, email: true },
  },
  {
    id: 'c3',
    phone: '0923456789',
    name: 'Lê Hoàng Cường',
    dateOfBirth: '1978-11-05',
    gender: 'male',
    tier: 'silver',
    points: 2100,
    walletBalance: 12_000_000,
    totalDeposited: 40_000_000,
    totalBonusEarned: 1_200_000,
    totalSpent: 29_200_000,
    referralCode: 'CUO4PL',
    createdAt: '2024-05-20T12:00:00Z',
    lastPurchaseAt: '2025-01-28T16:45:00Z',
    tags: [],
    notificationPreferences: { sms: true, zalo: false, email: false },
  },
  {
    id: 'c4',
    phone: '0934567890',
    name: 'Phạm Thị Dung',
    dateOfBirth: '1995-01-30',
    gender: 'female',
    tier: 'member',
    points: 450,
    walletBalance: 5_000_000,
    totalDeposited: 10_000_000,
    totalBonusEarned: 300_000,
    totalSpent: 5_300_000,
    referralCode: 'DUNG7R',
    createdAt: '2024-11-01T09:00:00Z',
    lastPurchaseAt: '2025-02-05T11:20:00Z',
    tags: ['low-spending'],
    notificationPreferences: { sms: true, zalo: false, email: false },
  },
  {
    id: 'c5',
    phone: '0945678901',
    name: 'Võ Minh Đức',
    dateOfBirth: '1982-09-18',
    gender: 'male',
    tier: 'gold',
    points: 7800,
    walletBalance: 32_500_000,
    totalDeposited: 90_000_000,
    totalBonusEarned: 2_700_000,
    totalSpent: 60_200_000,
    referralCode: 'DUC2KN',
    createdAt: '2023-12-05T14:00:00Z',
    lastPurchaseAt: '2025-02-11T10:00:00Z',
    tags: ['frequent-buyer'],
    notificationPreferences: { sms: true, zalo: true, email: false },
  },
  {
    id: 'c6',
    phone: '0956789012',
    name: 'Huỳnh Thị Hoa',
    dateOfBirth: '1988-04-12',
    gender: 'female',
    tier: 'silver',
    points: 3200,
    walletBalance: 18_700_000,
    totalDeposited: 50_000_000,
    totalBonusEarned: 1_500_000,
    totalSpent: 32_800_000,
    referralCode: 'HOA5TQ',
    createdAt: '2024-03-18T11:00:00Z',
    lastPurchaseAt: '2025-01-30T15:30:00Z',
    tags: [],
    notificationPreferences: { sms: true, zalo: true, email: true },
  },
  {
    id: 'c7',
    phone: '0967890123',
    name: 'Đặng Quốc Khánh',
    dateOfBirth: '1975-12-25',
    gender: 'male',
    tier: 'vip',
    points: 18500,
    walletBalance: 120_000_000,
    totalDeposited: 300_000_000,
    totalBonusEarned: 9_000_000,
    totalSpent: 189_000_000,
    referralCode: 'KHA8WZ',
    createdAt: '2023-03-01T08:00:00Z',
    lastPurchaseAt: '2025-02-13T08:45:00Z',
    tags: ['vip', 'high-deposit', 'frequent-buyer'],
    notificationPreferences: { sms: true, zalo: true, email: true },
  },
  {
    id: 'c8',
    phone: '0978901234',
    name: 'Ngô Thị Lan',
    dateOfBirth: '1992-06-08',
    gender: 'female',
    tier: 'member',
    points: 150,
    walletBalance: 0,
    totalDeposited: 0,
    totalBonusEarned: 0,
    totalSpent: 1_500_000,
    referralCode: 'LAN3FH',
    createdAt: '2025-01-10T10:00:00Z',
    lastPurchaseAt: '2025-01-15T13:00:00Z',
    tags: ['inactive'],
    notificationPreferences: { sms: true, zalo: false, email: false },
  },
  {
    id: 'c9',
    phone: '0989012345',
    name: 'Bùi Thanh Minh',
    dateOfBirth: '1980-08-20',
    gender: 'male',
    tier: 'gold',
    points: 6400,
    walletBalance: 28_000_000,
    totalDeposited: 70_000_000,
    totalBonusEarned: 2_100_000,
    totalSpent: 44_100_000,
    referralCode: 'MIN6YB',
    createdAt: '2024-02-14T09:00:00Z',
    lastPurchaseAt: '2025-02-08T17:00:00Z',
    tags: ['frequent-buyer'],
    notificationPreferences: { sms: true, zalo: false, email: true },
  },
  {
    id: 'c10',
    phone: '0990123456',
    name: 'Trương Thị Nhung',
    dateOfBirth: '1998-02-14',
    gender: 'female',
    tier: 'silver',
    points: 1800,
    walletBalance: 15_000_000,
    totalDeposited: 30_000_000,
    totalBonusEarned: 900_000,
    totalSpent: 15_900_000,
    referralCode: 'NHU4CD',
    createdAt: '2024-08-22T15:00:00Z',
    lastPurchaseAt: '2025-02-01T12:00:00Z',
    tags: [],
    notificationPreferences: { sms: true, zalo: true, email: false },
  },
  {
    id: 'c11',
    phone: '0901112233',
    name: 'Lý Văn Phong',
    dateOfBirth: '1970-05-10',
    gender: 'male',
    tier: 'member',
    points: 600,
    walletBalance: 8_500_000,
    totalDeposited: 10_000_000,
    totalBonusEarned: 300_000,
    totalSpent: 1_800_000,
    referralCode: 'PHO9EG',
    createdAt: '2024-10-05T08:00:00Z',
    lastPurchaseAt: '2024-12-20T14:00:00Z',
    tags: ['low-spending'],
    notificationPreferences: { sms: true, zalo: false, email: false },
  },
  {
    id: 'c12',
    phone: '0912223344',
    name: 'Mai Thị Quỳnh',
    dateOfBirth: '1993-10-03',
    gender: 'female',
    tier: 'gold',
    points: 9200,
    walletBalance: 55_000_000,
    totalDeposited: 130_000_000,
    totalBonusEarned: 3_900_000,
    totalSpent: 78_900_000,
    referralCode: 'QUY2HJ',
    createdAt: '2023-09-15T11:00:00Z',
    lastPurchaseAt: '2025-02-12T16:30:00Z',
    tags: ['high-deposit', 'frequent-buyer'],
    notificationPreferences: { sms: true, zalo: true, email: true },
  },
]

export const MOCK_WALLET_TRANSACTIONS: WalletTransaction[] = [
  {
    id: 'wt1',
    customerId: 'c1',
    type: 'deposit',
    amount: 30_000_000,
    balanceAfter: 75_300_000,
    description: 'Nạp tiền vào ví',
    createdAt: '2025-02-10T10:00:00Z',
  },
  {
    id: 'wt2',
    customerId: 'c1',
    type: 'bonus',
    amount: 750_000,
    balanceAfter: 76_050_000,
    description: 'Thưởng nạp tiền +2.5%',
    createdAt: '2025-02-10T10:00:01Z',
    relatedTransactionId: 'wt1',
  },
  {
    id: 'wt3',
    customerId: 'c1',
    type: 'purchase',
    amount: -15_200_000,
    balanceAfter: 61_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0234',
    createdAt: '2025-02-10T14:30:00Z',
  },
  {
    id: 'wt4',
    customerId: 'c1',
    type: 'purchase',
    amount: -15_700_000,
    balanceAfter: 45_300_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0251',
    createdAt: '2025-02-11T09:15:00Z',
  },
  {
    id: 'wt5',
    customerId: 'c2',
    type: 'deposit',
    amount: 50_000_000,
    balanceAfter: 135_000_000,
    description: 'Nạp tiền vào ví',
    createdAt: '2025-02-08T08:00:00Z',
  },
  {
    id: 'wt6',
    customerId: 'c2',
    type: 'bonus',
    amount: 1_250_000,
    balanceAfter: 136_250_000,
    description: 'Thưởng nạp tiền +2.5%',
    createdAt: '2025-02-08T08:00:01Z',
    relatedTransactionId: 'wt5',
  },
  {
    id: 'wt7',
    customerId: 'c2',
    type: 'purchase',
    amount: -28_500_000,
    balanceAfter: 108_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0198',
    createdAt: '2025-02-09T11:00:00Z',
  },
  {
    id: 'wt8',
    customerId: 'c2',
    type: 'purchase',
    amount: -23_000_000,
    balanceAfter: 85_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0267',
    createdAt: '2025-02-12T09:15:00Z',
  },
  {
    id: 'wt9',
    customerId: 'c3',
    type: 'deposit',
    amount: 10_000_000,
    balanceAfter: 22_000_000,
    description: 'Nạp tiền vào ví',
    createdAt: '2025-01-20T14:00:00Z',
  },
  {
    id: 'wt10',
    customerId: 'c3',
    type: 'bonus',
    amount: 250_000,
    balanceAfter: 22_250_000,
    description: 'Thưởng nạp tiền +2.5%',
    createdAt: '2025-01-20T14:00:01Z',
    relatedTransactionId: 'wt9',
  },
  {
    id: 'wt11',
    customerId: 'c3',
    type: 'purchase',
    amount: -10_300_000,
    balanceAfter: 12_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0156',
    createdAt: '2025-01-28T16:45:00Z',
  },
  {
    id: 'wt12',
    customerId: 'c5',
    type: 'deposit',
    amount: 20_000_000,
    balanceAfter: 52_500_000,
    description: 'Nạp tiền vào ví',
    createdAt: '2025-02-05T09:00:00Z',
  },
  {
    id: 'wt13',
    customerId: 'c5',
    type: 'bonus',
    amount: 500_000,
    balanceAfter: 53_000_000,
    description: 'Thưởng nạp tiền +2.5%',
    createdAt: '2025-02-05T09:00:01Z',
    relatedTransactionId: 'wt12',
  },
  {
    id: 'wt14',
    customerId: 'c5',
    type: 'purchase',
    amount: -20_600_000,
    balanceAfter: 32_500_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0245',
    createdAt: '2025-02-11T10:00:00Z',
  },
  {
    id: 'wt15',
    customerId: 'c7',
    type: 'deposit',
    amount: 100_000_000,
    balanceAfter: 220_000_000,
    description: 'Nạp tiền vào ví',
    createdAt: '2025-02-01T08:00:00Z',
  },
  {
    id: 'wt16',
    customerId: 'c7',
    type: 'bonus',
    amount: 2_500_000,
    balanceAfter: 222_500_000,
    description: 'Thưởng nạp tiền +2.5%',
    createdAt: '2025-02-01T08:00:01Z',
    relatedTransactionId: 'wt15',
  },
  {
    id: 'wt17',
    customerId: 'c7',
    type: 'purchase',
    amount: -55_000_000,
    balanceAfter: 168_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0180',
    createdAt: '2025-02-05T14:00:00Z',
  },
  {
    id: 'wt18',
    customerId: 'c7',
    type: 'purchase',
    amount: -48_000_000,
    balanceAfter: 120_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0270',
    createdAt: '2025-02-13T08:45:00Z',
  },
  {
    id: 'wt19',
    customerId: 'c4',
    type: 'deposit',
    amount: 10_000_000,
    balanceAfter: 10_000_000,
    description: 'Nạp tiền vào ví',
    createdAt: '2024-11-05T10:00:00Z',
  },
  {
    id: 'wt20',
    customerId: 'c4',
    type: 'bonus',
    amount: 250_000,
    balanceAfter: 10_250_000,
    description: 'Thưởng nạp tiền +2.5%',
    createdAt: '2024-11-05T10:00:01Z',
    relatedTransactionId: 'wt19',
  },
  {
    id: 'wt21',
    customerId: 'c4',
    type: 'purchase',
    amount: -5_300_000,
    balanceAfter: 5_000_000,
    description: 'Thanh toán đơn hàng #MHP-2025-0089',
    createdAt: '2025-02-05T11:20:00Z',
  },
  {
    id: 'wt22',
    customerId: 'c6',
    type: 'refund',
    amount: 2_500_000,
    balanceAfter: 21_200_000,
    description: 'Hoàn tiền đơn hàng #MHP-2025-0102',
    createdAt: '2025-01-25T10:00:00Z',
  },
]

export const MOCK_POINTS_TRANSACTIONS: PointsTransaction[] = [
  {
    id: 'pt1',
    customerId: 'c1',
    type: 'earn',
    points: 152,
    balanceAfter: 8750,
    description: 'Mua hàng #MHP-2025-0234',
    createdAt: '2025-02-10T14:30:00Z',
    multiplier: 1,
  },
  {
    id: 'pt2',
    customerId: 'c1',
    type: 'earn',
    points: 157,
    balanceAfter: 8598,
    description: 'Mua hàng #MHP-2025-0251',
    createdAt: '2025-02-11T09:15:00Z',
    multiplier: 1,
  },
  {
    id: 'pt3',
    customerId: 'c2',
    type: 'earn',
    points: 570,
    balanceAfter: 22300,
    description: 'Mua hàng #MHP-2025-0198 (x2 VIP)',
    createdAt: '2025-02-09T11:00:00Z',
    multiplier: 2,
  },
  {
    id: 'pt4',
    customerId: 'c2',
    type: 'earn',
    points: 460,
    balanceAfter: 21730,
    description: 'Mua hàng #MHP-2025-0267 (x2 VIP)',
    createdAt: '2025-02-12T09:15:00Z',
    multiplier: 2,
  },
  {
    id: 'pt5',
    customerId: 'c2',
    type: 'redeem',
    points: -500,
    balanceAfter: 21270,
    description: 'Đổi phần thưởng: Voucher 500K',
    createdAt: '2025-02-06T15:00:00Z',
  },
  {
    id: 'pt6',
    customerId: 'c3',
    type: 'earn',
    points: 103,
    balanceAfter: 2100,
    description: 'Mua hàng #MHP-2025-0156',
    createdAt: '2025-01-28T16:45:00Z',
    multiplier: 1,
  },
  {
    id: 'pt7',
    customerId: 'c5',
    type: 'earn',
    points: 309,
    balanceAfter: 7800,
    description: 'Mua hàng #MHP-2025-0245 (x1.5 Gold)',
    createdAt: '2025-02-11T10:00:00Z',
    multiplier: 1.5,
  },
  {
    id: 'pt8',
    customerId: 'c7',
    type: 'earn',
    points: 1100,
    balanceAfter: 18500,
    description: 'Mua hàng #MHP-2025-0180 (x2 VIP)',
    createdAt: '2025-02-05T14:00:00Z',
    multiplier: 2,
  },
  {
    id: 'pt9',
    customerId: 'c7',
    type: 'earn',
    points: 960,
    balanceAfter: 17540,
    description: 'Mua hàng #MHP-2025-0270 (x2 VIP)',
    createdAt: '2025-02-13T08:45:00Z',
    multiplier: 2,
  },
  {
    id: 'pt10',
    customerId: 'c9',
    type: 'earn',
    points: 200,
    balanceAfter: 6400,
    description: 'Mua hàng #MHP-2025-0220 (x1.5 Gold)',
    createdAt: '2025-02-08T17:00:00Z',
    multiplier: 1.5,
  },
]

export const MOCK_PROMOTIONS: Promotion[] = [
  {
    id: 'promo1',
    name: 'Lunar New Year Double Points',
    nameVi: 'Tết Nguyên Đán - Điểm Nhân Đôi',
    description: 'Nhân đôi điểm thưởng cho tất cả giao dịch trong dịp Tết',
    type: 'time-window',
    status: 'active',
    startDate: '2025-01-25T00:00:00Z',
    endDate: '2025-02-15T23:59:59Z',
    pointMultiplier: 2,
    targetSegments: [],
    createdBy: 'staff1',
    createdAt: '2025-01-20T10:00:00Z',
  },
  {
    id: 'promo2',
    name: 'VIP Exclusive Discount',
    nameVi: 'Ưu Đãi Dành Riêng VIP',
    description: 'Giảm thêm 5% cho khách hàng VIP trên tất cả sản phẩm',
    type: 'segment',
    status: 'active',
    startDate: '2025-02-01T00:00:00Z',
    endDate: '2025-02-28T23:59:59Z',
    discountPercent: 5,
    targetSegments: ['vip'],
    createdBy: 'staff1',
    createdAt: '2025-01-28T09:00:00Z',
  },
  {
    id: 'promo3',
    name: 'Weekend Bonus Credits',
    nameVi: 'Cuối Tuần Thưởng Thêm Tín Dụng',
    description: 'Nạp tiền cuối tuần được thưởng thêm 2% (tổng 4.5%)',
    type: 'time-window',
    status: 'scheduled',
    startDate: '2025-03-01T00:00:00Z',
    endDate: '2025-03-31T23:59:59Z',
    bonusCredits: 2,
    targetSegments: [],
    createdBy: 'staff2',
    createdAt: '2025-02-10T14:00:00Z',
  },
  {
    id: 'promo4',
    name: 'Brake Parts Triple Points',
    nameVi: 'Phụ Tùng Phanh - Điểm x3',
    description: 'Nhận gấp 3 điểm khi mua phụ tùng phanh',
    type: 'category',
    status: 'expired',
    startDate: '2025-01-01T00:00:00Z',
    endDate: '2025-01-31T23:59:59Z',
    pointMultiplier: 3,
    targetCategories: ['brake-parts'],
    createdBy: 'staff2',
    createdAt: '2024-12-25T10:00:00Z',
  },
  {
    id: 'promo5',
    name: 'New Member Welcome',
    nameVi: 'Chào Mừng Thành Viên Mới',
    description: 'Thưởng 100 điểm cho thành viên mới đăng ký',
    type: 'segment',
    status: 'active',
    startDate: '2024-01-01T00:00:00Z',
    endDate: '2025-12-31T23:59:59Z',
    bonusCredits: 0,
    pointMultiplier: 1,
    createdBy: 'staff1',
    createdAt: '2024-01-01T00:00:00Z',
  },
]

export const MOCK_STAFF: StaffAccount[] = [
  {
    id: 'staff1',
    name: 'Nguyễn Thành Long',
    phone: '0901000001',
    email: 'long@myhoaphat.com',
    role: 'owner',
    isActive: true,
    createdAt: '2023-01-01T00:00:00Z',
    lastLoginAt: '2025-02-14T08:00:00Z',
  },
  {
    id: 'staff2',
    name: 'Trần Minh Tuấn',
    phone: '0901000002',
    email: 'tuan@myhoaphat.com',
    role: 'manager',
    isActive: true,
    createdAt: '2023-03-15T00:00:00Z',
    lastLoginAt: '2025-02-14T07:30:00Z',
  },
  {
    id: 'staff3',
    name: 'Lê Thị Hương',
    phone: '0901000003',
    email: 'huong@myhoaphat.com',
    role: 'cashier',
    isActive: true,
    createdAt: '2024-01-10T00:00:00Z',
    lastLoginAt: '2025-02-13T17:00:00Z',
  },
  {
    id: 'staff4',
    name: 'Phạm Văn Đạt',
    phone: '0901000004',
    email: 'dat@myhoaphat.com',
    role: 'marketing',
    isActive: true,
    createdAt: '2024-06-01T00:00:00Z',
    lastLoginAt: '2025-02-12T16:00:00Z',
  },
  {
    id: 'staff5',
    name: 'Hoàng Thị Mai',
    phone: '0901000005',
    email: 'mai@myhoaphat.com',
    role: 'cashier',
    isActive: false,
    createdAt: '2024-03-20T00:00:00Z',
    lastLoginAt: '2024-11-30T15:00:00Z',
  },
]

export const MOCK_AUDIT_LOGS: AuditLog[] = [
  {
    id: 'al1',
    staffId: 'staff1',
    staffName: 'Nguyễn Thành Long',
    action: 'Cập nhật tỷ lệ thưởng nạp tiền',
    actionType: 'update',
    targetType: 'settings',
    details: 'Thay đổi bonus từ 2% sang 2.5%',
    isFlagged: false,
    createdAt: '2025-02-13T10:00:00Z',
  },
  {
    id: 'al2',
    staffId: 'staff3',
    staffName: 'Lê Thị Hương',
    action: 'Xử lý thanh toán',
    actionType: 'create',
    targetType: 'wallet',
    targetId: 'c1',
    details: 'Thanh toán 15.200.000đ cho KH Nguyễn Văn An',
    isFlagged: false,
    createdAt: '2025-02-10T14:30:00Z',
  },
  {
    id: 'al3',
    staffId: 'staff2',
    staffName: 'Trần Minh Tuấn',
    action: 'Điều chỉnh điểm thủ công',
    actionType: 'adjustment',
    targetType: 'points',
    targetId: 'c6',
    details: 'Cộng 50 điểm bù cho KH Huỳnh Thị Hoa - lỗi hệ thống',
    isFlagged: true,
    createdAt: '2025-02-09T16:00:00Z',
  },
  {
    id: 'al4',
    staffId: 'staff4',
    staffName: 'Phạm Văn Đạt',
    action: 'Tạo khuyến mãi mới',
    actionType: 'create',
    targetType: 'promotion',
    targetId: 'promo3',
    details: 'Tạo chương trình Cuối Tuần Thưởng Thêm Tín Dụng',
    isFlagged: false,
    createdAt: '2025-02-10T14:00:00Z',
  },
  {
    id: 'al5',
    staffId: 'staff1',
    staffName: 'Nguyễn Thành Long',
    action: 'Đăng nhập hệ thống',
    actionType: 'login',
    targetType: 'system',
    details: 'Đăng nhập từ IP 192.168.1.100',
    isFlagged: false,
    createdAt: '2025-02-14T08:00:00Z',
  },
  {
    id: 'al6',
    staffId: 'staff3',
    staffName: 'Lê Thị Hương',
    action: 'Hoàn tiền cho khách',
    actionType: 'adjustment',
    targetType: 'wallet',
    targetId: 'c6',
    details: 'Hoàn 2.500.000đ cho KH Huỳnh Thị Hoa',
    isFlagged: false,
    createdAt: '2025-01-25T10:00:00Z',
  },
  {
    id: 'al7',
    staffId: 'staff2',
    staffName: 'Trần Minh Tuấn',
    action: 'Phê duyệt điều chỉnh',
    actionType: 'approval',
    targetType: 'wallet',
    targetId: 'c8',
    details: 'Phê duyệt cộng 1.000.000đ cho KH Ngô Thị Lan',
    isFlagged: false,
    createdAt: '2025-02-07T11:00:00Z',
  },
  {
    id: 'al8',
    staffId: 'staff3',
    staffName: 'Lê Thị Hương',
    action: 'Điều chỉnh ví bất thường',
    actionType: 'adjustment',
    targetType: 'wallet',
    targetId: 'c8',
    details: 'Cộng 5.000.000đ không có chứng từ',
    isFlagged: true,
    createdAt: '2025-02-06T22:30:00Z',
  },
  {
    id: 'al9',
    staffId: 'staff1',
    staffName: 'Nguyễn Thành Long',
    action: 'Vô hiệu hóa nhân viên',
    actionType: 'update',
    targetType: 'staff',
    targetId: 'staff5',
    details: 'Vô hiệu hóa tài khoản Hoàng Thị Mai',
    isFlagged: false,
    createdAt: '2024-12-01T09:00:00Z',
  },
  {
    id: 'al10',
    staffId: 'staff2',
    staffName: 'Trần Minh Tuấn',
    action: 'Cập nhật hạng thành viên',
    actionType: 'update',
    targetType: 'customer',
    targetId: 'c2',
    details: 'Nâng hạng KH Trần Thị Bích lên VIP',
    isFlagged: false,
    createdAt: '2025-01-15T10:00:00Z',
  },
]

export const MOCK_REWARDS: Reward[] = [
  {
    id: 'r1',
    name: 'Store Credit 200K',
    nameVi: 'Tín Dụng Mua Hàng 200.000đ',
    description: 'Cộng 200.000đ tín dụng vào ví mua hàng',
    pointsCost: 400,
    category: 'voucher',
    isAvailable: true,
    stock: 50,
    redeemedCount: 120,
  },
  {
    id: 'r2',
    name: 'Store Credit 500K',
    nameVi: 'Tín Dụng Mua Hàng 500.000đ',
    description: 'Cộng 500.000đ tín dụng vào ví mua hàng',
    pointsCost: 1000,
    category: 'voucher',
    isAvailable: true,
    stock: 30,
    redeemedCount: 85,
  },
  {
    id: 'r3',
    name: 'Free Oil Change',
    nameVi: 'Thay Nhớt Miễn Phí',
    description: 'Miễn phí 1 lần thay nhớt tại cửa hàng',
    pointsCost: 500,
    category: 'service',
    isAvailable: true,
    stock: 20,
    redeemedCount: 45,
  },
  {
    id: 'r4',
    name: 'MHP Branded T-Shirt',
    nameVi: 'Áo Thun MHP',
    description: 'Áo thun thương hiệu Mỹ Hòa Phát',
    pointsCost: 200,
    category: 'merchandise',
    isAvailable: true,
    stock: 100,
    redeemedCount: 200,
  },
  {
    id: 'r5',
    name: 'Store Credit 1M',
    nameVi: 'Tín Dụng Mua Hàng 1.000.000đ',
    description: 'Cộng 1.000.000đ tín dụng vào ví mua hàng',
    pointsCost: 2000,
    category: 'voucher',
    isAvailable: true,
    stock: 10,
    redeemedCount: 15,
  },
  {
    id: 'r6',
    name: 'Birthday Special 500K',
    nameVi: 'Quà Sinh Nhật 500.000đ',
    description: 'Tín dụng đặc biệt sinh nhật trị giá 500.000đ',
    pointsCost: 0,
    category: 'birthday',
    isAvailable: false,
    stock: 0,
    redeemedCount: 30,
  },
]

export const MOCK_PURCHASES: Purchase[] = [
  {
    id: 'p1',
    customerId: 'c1',
    amount: 15_200_000,
    creditsUsed: 15_200_000,
    discountApplied: 760_000,
    pointsEarned: 152,
    tierAtPurchase: 'gold',
    createdAt: '2025-02-10T14:30:00Z',
  },
  {
    id: 'p2',
    customerId: 'c1',
    amount: 15_700_000,
    creditsUsed: 15_700_000,
    discountApplied: 785_000,
    pointsEarned: 157,
    tierAtPurchase: 'gold',
    createdAt: '2025-02-11T09:15:00Z',
  },
  {
    id: 'p3',
    customerId: 'c2',
    amount: 28_500_000,
    creditsUsed: 28_500_000,
    discountApplied: 2_850_000,
    pointsEarned: 570,
    tierAtPurchase: 'vip',
    createdAt: '2025-02-09T11:00:00Z',
  },
  {
    id: 'p4',
    customerId: 'c2',
    amount: 23_000_000,
    creditsUsed: 23_000_000,
    discountApplied: 2_300_000,
    pointsEarned: 460,
    tierAtPurchase: 'vip',
    createdAt: '2025-02-12T09:15:00Z',
  },
  {
    id: 'p5',
    customerId: 'c3',
    amount: 10_300_000,
    creditsUsed: 10_300_000,
    discountApplied: 309_000,
    pointsEarned: 103,
    tierAtPurchase: 'silver',
    createdAt: '2025-01-28T16:45:00Z',
  },
  {
    id: 'p6',
    customerId: 'c5',
    amount: 20_600_000,
    creditsUsed: 20_600_000,
    discountApplied: 1_030_000,
    pointsEarned: 309,
    tierAtPurchase: 'gold',
    createdAt: '2025-02-11T10:00:00Z',
  },
  {
    id: 'p7',
    customerId: 'c7',
    amount: 55_000_000,
    creditsUsed: 55_000_000,
    discountApplied: 5_500_000,
    pointsEarned: 1100,
    tierAtPurchase: 'vip',
    createdAt: '2025-02-05T14:00:00Z',
  },
  {
    id: 'p8',
    customerId: 'c7',
    amount: 48_000_000,
    creditsUsed: 48_000_000,
    discountApplied: 4_800_000,
    pointsEarned: 960,
    tierAtPurchase: 'vip',
    createdAt: '2025-02-13T08:45:00Z',
  },
]

export const MOCK_WALLET_SETTINGS: WalletSettings = {
  bonusPercent: 2.5,
  depositIncrement: 10_000_000,
  minimumDeposit: 10_000_000,
  expirationMonths: 12,
  allowRefunds: true,
  maxRefundDays: 30,
}

export const MOCK_POINTS_SETTINGS: PointsSettings = {
  vndPerPoint: 100_000,
  defaultMultiplier: 1,
  redemptionEnabled: true,
  pointsPerRedemptionUnit: 1000,
  redemptionUnitValueVnd: 500_000,
}

export const MOCK_NOTIFICATION_TEMPLATES: NotificationTemplate[] = [
  {
    id: 'nt1',
    event: 'signup_success',
    eventVi: 'Đăng ký thành công',
    smsTemplate: 'Chào mừng {name} đến với Mỹ Hòa Phát! Mã thành viên: {code}',
    zaloTemplate: 'Chào mừng bạn!',
    emailTemplate: '',
    isActive: true,
  },
  {
    id: 'nt2',
    event: 'deposit_success',
    eventVi: 'Nạp tiền thành công',
    smsTemplate: '{name}, bạn đã nạp {amount} và nhận thêm {bonus} thưởng!',
    zaloTemplate: 'Nạp tiền thành công!',
    emailTemplate: '',
    isActive: true,
  },
  {
    id: 'nt3',
    event: 'tier_upgrade',
    eventVi: 'Nâng hạng thành viên',
    smsTemplate: 'Chúc mừng {name}! Bạn đã được nâng hạng lên {tier}!',
    zaloTemplate: 'Nâng hạng thành công!',
    emailTemplate: '',
    isActive: true,
  },
  {
    id: 'nt4',
    event: 'birthday_reward',
    eventVi: 'Quà sinh nhật',
    smsTemplate: 'Chúc mừng sinh nhật {name}! MHP tặng bạn {reward}!',
    zaloTemplate: 'Chúc mừng sinh nhật!',
    emailTemplate: '',
    isActive: true,
  },
  {
    id: 'nt5',
    event: 'expiring_credits',
    eventVi: 'Tín dụng sắp hết hạn',
    smsTemplate:
      '{name}, {amount} tín dụng sẽ hết hạn vào {date}. Hãy sử dụng ngay!',
    zaloTemplate: 'Tín dụng sắp hết hạn!',
    emailTemplate: '',
    isActive: true,
  },
  {
    id: 'nt6',
    event: 'purchase_confirmation',
    eventVi: 'Xác nhận mua hàng',
    smsTemplate:
      '{name}, đơn hàng {orderId} đã thanh toán {amount}. Điểm tích lũy: +{points}',
    zaloTemplate: 'Thanh toán thành công!',
    emailTemplate: '',
    isActive: false,
  },
]

export const MOCK_DASHBOARD_STATS: DashboardStats = {
  totalMembers: 1247,
  activeMembers30d: 892,
  activeMembers60d: 1056,
  activeMembers90d: 1180,
  totalDeposited: 8_750_000_000,
  totalBonusIssued: 262_500_000,
  totalCreditsRedeemed: 5_230_000_000,
  unredeemedLiability: 3_782_500_000,
  memberRevenue: 12_500_000_000,
  nonMemberRevenue: 4_200_000_000,
  repeatPurchaseRate: 72.5,
  averageBasketSize: 18_500_000,
}

export const MOCK_MEMBER_GROWTH: ChartDataPoint[] = [
  { label: 'T8/24', value: 780 },
  { label: 'T9/24', value: 845 },
  { label: 'T10/24', value: 920 },
  { label: 'T11/24', value: 985 },
  { label: 'T12/24', value: 1065 },
  { label: 'T1/25', value: 1150 },
  { label: 'T2/25', value: 1247 },
]

export const MOCK_DEPOSIT_TRENDS: ChartDataPoint[] = [
  { label: 'T8/24', value: 950_000_000 },
  { label: 'T9/24', value: 1_100_000_000 },
  { label: 'T10/24', value: 1_250_000_000 },
  { label: 'T11/24', value: 1_050_000_000 },
  { label: 'T12/24', value: 1_450_000_000 },
  { label: 'T1/25', value: 1_350_000_000 },
  { label: 'T2/25', value: 1_600_000_000 },
]

export const MOCK_CREDIT_USAGE: ChartDataPoint[] = [
  { label: 'T8/24', value: 620_000_000, value2: 330_000_000 },
  { label: 'T9/24', value: 710_000_000, value2: 390_000_000 },
  { label: 'T10/24', value: 780_000_000, value2: 470_000_000 },
  { label: 'T11/24', value: 690_000_000, value2: 360_000_000 },
  { label: 'T12/24', value: 850_000_000, value2: 600_000_000 },
  { label: 'T1/25', value: 920_000_000, value2: 430_000_000 },
  { label: 'T2/25', value: 660_000_000, value2: 940_000_000 },
]

export const MOCK_TIER_DISTRIBUTION: ChartDataPoint[] = [
  { label: 'Thành Viên', value: 520 },
  { label: 'Bạc', value: 410 },
  { label: 'Vàng', value: 245 },
  { label: 'VIP', value: 72 },
]
